module.exports = __webpack_public_path__ + "img/40_38_035_250.45419715.jpg";